(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slider-show"]) return;
  try {
    
var autoplay_options = {
delay: 6000,
stopOnLastSlide: false,
disableOnInteraction: true,
}
var autoplay = window.innerWidth > 1024 ? autoplay_options : true;
var swiper_main = new Swiper('.hero-slider', {
autoplay: autoplay,
observer: true,
loop: true,
observeParents: true,
noSwiping : true,
pagination: {
el: '.swiper-pagination',
clickable: true,
bulletClass: 'swiper-custom-bullet',
renderBullet: function (index, className) {
return '<span class="' + className + '"></span>';
}
},
navigation: {
nextEl: '.swiper-button-next',
prevEl: '.swiper-button-prev',
},
// on: {
// transitionStart: function(){
// if(this.realIndex != 0){
// this.autoplay.start();
// }else{
// this.autoplay.stop();
// }
// }
// }
});

$(".hero-slider").hover(
function () {
swiper_main.autoplay.stop();
},
function () {
swiper_main.autoplay.start();
}
);

// var swiper_l = new Swiper("#swiper_sub_l", {
// autoplay: {
// delay: 4000,
// stopOnLastSlide: false,
// disableOnInteraction: true,
// },
// effect: 'fade',
// observer: true,
// observeParents: true,
// roundLengths: true,
// fadeEffect: {
// crossFade: true,
// }
// });
// setTimeout(() => {
// var swiper_r = new Swiper("#swiper_sub_r", {
// autoplay: {
// delay: 4000,
// stopOnLastSlide: false,
// disableOnInteraction: true,
// },
// effect: 'fade',
// observer: true,
// observeParents: true,
// roundLengths: true,
// fadeEffect: {
// crossFade: true,
// }
// });
// }, 2000)

  } catch(e) { console.error(e); }
})();
})();
